interface Theme {
  white: string
  lightGrey: string
  primary: string
  lightPrimary: string
  secondary: string
}

export const theme: Theme = {
  white: "#ffffff",
  lightGrey: "#f4f4f4",
  primary: "#127c8a",
  lightPrimary: "#a9d5dA",
  secondary: "#a02334",
}
